// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"600fe7fd","194":"c735bc5b","352":"d2c59578","515":"bb9fb1fe"}[chunkId] + ".chunk.js";
};